import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { useAddNotesMutation } from "../service/booking";
import { showError, showToast } from "../constants/toasts";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  bookingId?: string | undefined;
}

export default function AddNote({
  open,
  onClose,
  setOpen,
  bookingId,
}: AddCategoryModalProps) {
  const [addNotes] = useAddNotesMutation();
  const [notes, setNotes] = useState("");
  const [error, setError] = useState(false);

  const addNotesApi = async () => {
    setError(true);

    if (!notes) {
      showError("Please enter note");
      return;
    }

    try {
      const body = {
        bookingId,
        notes: notes,
      };

      const response = await addNotes(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        setOpen(false);
        setNotes("");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Note</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                placeholder="Enter Note"
                fullWidth
                hiddenLabel
                multiline={true}
                minRows={3}
                value={notes}
                inputProps={{ maxLength: 150 }}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setNotes(e.target.value);
                  }
                }}
              />
              {error && notes == "" ? (
                <h6 className="err_msg">Note is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={addNotesApi}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
